const t = {
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight"
}, o = "https://static.dialpadcdn.com/joypixels/png/unicode/32/", _ = 9, R = {
  DEFAULT: "Default",
  LIGHT: "Light",
  MEDIUM_LIGHT: "MediumLight",
  MEDIUM: "Medium",
  MEDIUM_DARK: "MediumDark",
  DARK: "Dark"
}, D = {
  EMOJI_PICKER_SKIN_TONE_MODIFIERS: R
};
export {
  t as ARROW_KEYS,
  o as CDN_URL,
  _ as EMOJIS_PER_ROW,
  R as EMOJI_PICKER_SKIN_TONE_MODIFIERS,
  D as default
};
//# sourceMappingURL=emoji-picker-constants.js.map
